import Icon from '../components/Icon.vue'

Icon.register({
  'text-width': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M432 32c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16h-120v112h24c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h24v-112h-120v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-80c0-8.8 7.2-16 16-16h416zM363.3 292.7l80 80c2.6 2.6 4.7 7.7 4.7 11.3s-2.1 8.7-4.7 11.3l-80 80c-10 10-27.3 3-27.3-11.3v-48h-224v48c0 15.6-18 20.6-27.3 11.3l-80-80c-2.6-2.6-4.7-7.7-4.7-11.3s2.1-8.7 4.7-11.3l80-80c10-10 27.3-3 27.3 11.3v48h224v-48c0-15.6 18-20.6 27.3-11.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/text-width.js
// module id = 1993
// module chunks = 0